module.exports = __webpack_public_path__ + "static/media/icon-solutions-02.43e447d8.svg";